import { observer } from 'mobx-react-lite';
import styles from './NavBar.module.css';

const NavBar = () => {
    return (
        <div className={styles.header}>
            <div>
                <a href="/"><img src="/assets/logo.png" width="150" /></a>
            </div>
            <nav>
                <a href="#contact">Контакты</a>
            </nav>
        </div>
    );
};

export default observer(NavBar)